// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fin-container {
  max-width: var(--content-max, 1400px);
  margin: 0 auto;
}

.fin-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 28px;
}
.fin-header p {
  color: var(--text-dim, #6B6858);
  margin-top: 6px;
}

.fin-container .error-message {
  background: var(--red-bg, #F8E3E0);
  color: var(--red, #B33A2E);
  padding: 12px 16px;
  border-radius: var(--radius, 12px);
  font-size: 13.5px;
  margin-bottom: 20px;
}

.fin-loading {
  padding: 60px;
  text-align: center;
  color: var(--text-dim, #6B6858);
}

/* ── KPIs ── */
.fin-kpi-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.fin-kpi {
  background: #fff;
  border: 1px solid var(--line, #DEDACB);
  border-radius: var(--radius, 12px);
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.fin-kpi-label {
  font-size: 12px;
  color: var(--text-dim, #6B6858);
  text-transform: uppercase;
  letter-spacing: .04em;
  font-weight: 600;
}
.fin-kpi-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 26px;
  font-weight: 600;
  color: var(--text, #1A1810);
}
.fin-kpi-sub {
  font-size: 12.5px;
  color: var(--text-dim, #6B6858);
}
.fin-kpi-green { border-left: 3px solid var(--green, #1E7A44); }
.fin-kpi-green .fin-kpi-value { color: var(--green, #1E7A44); }
.fin-kpi-amber { border-left: 3px solid var(--amber, #C77C1F); }
.fin-kpi-amber .fin-kpi-value { color: var(--amber, #C77C1F); }

/* ── Grid de cards ── */
.fin-grid-2 {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}
.fin-card h3 {
  font-size: 15px;
  color: var(--text, #1A1810);
  margin-bottom: 16px;
}
.fin-empty-hint {
  font-size: 13px;
  color: var(--text-dim, #6B6858);
}
.fin-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 999px;
  background: var(--amber-bg, #F6E6CE);
  color: var(--amber, #C77C1F);
  font-size: 12px;
  font-weight: 700;
  margin-left: 8px;
}

/* ── Barras receita por campeonato ── */
.fin-bar-list { display: flex; flex-direction: column; gap: 16px; }
.fin-bar-row { cursor: pointer; }
.fin-bar-label {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 13.5px;
  margin-bottom: 6px;
  gap: 10px;
}
.fin-bar-label span {
  color: var(--text, #1A1810);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fin-bar-label b {
  font-family: 'JetBrains Mono', monospace;
  color: var(--green, #1E7A44);
  flex-shrink: 0;
}
.fin-bar-track {
  position: relative;
  height: 10px;
  background: var(--paper-dim, #F0ECE0);
  border-radius: 999px;
  overflow: hidden;
}
.fin-bar-track-sm { height: 8px; }
.fin-bar-fill {
  position: absolute;
  top: 0; left: 0; height: 100%;
  border-radius: 999px;
  transition: width .3s ease;
}
.fin-bar-confirmada { background: var(--green, #1E7A44); }
.fin-bar-pendente { background: var(--amber, #C77C1F); opacity: .55; }
.fin-bar-meta {
  display: flex;
  gap: 12px;
  margin-top: 6px;
  font-size: 11.5px;
  color: var(--text-dim, #6B6858);
}
.fin-meta-amber { color: var(--amber, #C77C1F); font-weight: 600; }

/* ── Formas de pagamento ── */
.fin-forma-list { display: flex; flex-direction: column; gap: 14px; }
.fin-forma-row { display: flex; flex-direction: column; gap: 6px; }
.fin-forma-label {
  display: flex;
  justify-content: space-between;
  font-size: 13.5px;
}
.fin-forma-label span { color: var(--text, #1A1810); font-weight: 600; }
.fin-forma-label b { font-family: 'JetBrains Mono', monospace; color: var(--text, #1A1810); }
.fin-forma-qtd {
  font-size: 11.5px;
  color: var(--text-dim, #6B6858);
  align-self: flex-end;
}

@media (max-width: 900px) {
  .fin-grid-2 { grid-template-columns: 1fr; }
  .fin-header { flex-direction: column; align-items: flex-start; gap: 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Financeiro.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;AACA,iBAAiB,4CAA4C,EAAE;AAC/D,gCAAgC,4BAA4B,EAAE;AAC9D,iBAAiB,4CAA4C,EAAE;AAC/D,gCAAgC,4BAA4B,EAAE;;AAE9D,wBAAwB;AACxB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAClE,eAAe,eAAe,EAAE;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;AAClB;AACA,oBAAoB,WAAW,EAAE;AACjC;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,YAAY;EAC7B,oBAAoB;EACpB,0BAA0B;AAC5B;AACA,sBAAsB,iCAAiC,EAAE;AACzD,oBAAoB,iCAAiC,EAAE,YAAY,EAAE;AACrE;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;AACA,kBAAkB,4BAA4B,EAAE,gBAAgB,EAAE;;AAElE,8BAA8B;AAC9B,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACpE,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAClE;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;AACA,wBAAwB,2BAA2B,EAAE,gBAAgB,EAAE;AACvE,qBAAqB,wCAAwC,EAAE,2BAA2B,EAAE;AAC5F;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,cAAc,0BAA0B,EAAE;EAC1C,cAAc,sBAAsB,EAAE,uBAAuB,EAAE,SAAS,EAAE;AAC5E","sourcesContent":[".fin-container {\n  max-width: var(--content-max, 1400px);\n  margin: 0 auto;\n}\n\n.fin-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 28px;\n}\n.fin-header p {\n  color: var(--text-dim, #6B6858);\n  margin-top: 6px;\n}\n\n.fin-container .error-message {\n  background: var(--red-bg, #F8E3E0);\n  color: var(--red, #B33A2E);\n  padding: 12px 16px;\n  border-radius: var(--radius, 12px);\n  font-size: 13.5px;\n  margin-bottom: 20px;\n}\n\n.fin-loading {\n  padding: 60px;\n  text-align: center;\n  color: var(--text-dim, #6B6858);\n}\n\n/* ── KPIs ── */\n.fin-kpi-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n.fin-kpi {\n  background: #fff;\n  border: 1px solid var(--line, #DEDACB);\n  border-radius: var(--radius, 12px);\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.fin-kpi-label {\n  font-size: 12px;\n  color: var(--text-dim, #6B6858);\n  text-transform: uppercase;\n  letter-spacing: .04em;\n  font-weight: 600;\n}\n.fin-kpi-value {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 26px;\n  font-weight: 600;\n  color: var(--text, #1A1810);\n}\n.fin-kpi-sub {\n  font-size: 12.5px;\n  color: var(--text-dim, #6B6858);\n}\n.fin-kpi-green { border-left: 3px solid var(--green, #1E7A44); }\n.fin-kpi-green .fin-kpi-value { color: var(--green, #1E7A44); }\n.fin-kpi-amber { border-left: 3px solid var(--amber, #C77C1F); }\n.fin-kpi-amber .fin-kpi-value { color: var(--amber, #C77C1F); }\n\n/* ── Grid de cards ── */\n.fin-grid-2 {\n  display: grid;\n  grid-template-columns: 1.3fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n.fin-card h3 {\n  font-size: 15px;\n  color: var(--text, #1A1810);\n  margin-bottom: 16px;\n}\n.fin-empty-hint {\n  font-size: 13px;\n  color: var(--text-dim, #6B6858);\n}\n.fin-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: var(--amber-bg, #F6E6CE);\n  color: var(--amber, #C77C1F);\n  font-size: 12px;\n  font-weight: 700;\n  margin-left: 8px;\n}\n\n/* ── Barras receita por campeonato ── */\n.fin-bar-list { display: flex; flex-direction: column; gap: 16px; }\n.fin-bar-row { cursor: pointer; }\n.fin-bar-label {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  font-size: 13.5px;\n  margin-bottom: 6px;\n  gap: 10px;\n}\n.fin-bar-label span {\n  color: var(--text, #1A1810);\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.fin-bar-label b {\n  font-family: 'JetBrains Mono', monospace;\n  color: var(--green, #1E7A44);\n  flex-shrink: 0;\n}\n.fin-bar-track {\n  position: relative;\n  height: 10px;\n  background: var(--paper-dim, #F0ECE0);\n  border-radius: 999px;\n  overflow: hidden;\n}\n.fin-bar-track-sm { height: 8px; }\n.fin-bar-fill {\n  position: absolute;\n  top: 0; left: 0; height: 100%;\n  border-radius: 999px;\n  transition: width .3s ease;\n}\n.fin-bar-confirmada { background: var(--green, #1E7A44); }\n.fin-bar-pendente { background: var(--amber, #C77C1F); opacity: .55; }\n.fin-bar-meta {\n  display: flex;\n  gap: 12px;\n  margin-top: 6px;\n  font-size: 11.5px;\n  color: var(--text-dim, #6B6858);\n}\n.fin-meta-amber { color: var(--amber, #C77C1F); font-weight: 600; }\n\n/* ── Formas de pagamento ── */\n.fin-forma-list { display: flex; flex-direction: column; gap: 14px; }\n.fin-forma-row { display: flex; flex-direction: column; gap: 6px; }\n.fin-forma-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13.5px;\n}\n.fin-forma-label span { color: var(--text, #1A1810); font-weight: 600; }\n.fin-forma-label b { font-family: 'JetBrains Mono', monospace; color: var(--text, #1A1810); }\n.fin-forma-qtd {\n  font-size: 11.5px;\n  color: var(--text-dim, #6B6858);\n  align-self: flex-end;\n}\n\n@media (max-width: 900px) {\n  .fin-grid-2 { grid-template-columns: 1fr; }\n  .fin-header { flex-direction: column; align-items: flex-start; gap: 10px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
